import type { AxiosRequestConfig } from 'axios';
import type {
  CompanyId,
  UserJourneyCacheId,
  Vehicle,
  AppliedRoleId,
  RoleContext,
  VehicleId,
  Market,
  MarketId,
  UserLocale,
} from '@dh-io-mhb2b/api-model';
import { loadActiveProfileFromStore } from '../../active-profile-store/utils/utils-state';
import { aemEnvironmentHandler } from '../../aem/aem-environment';

export interface ActiveProfileHeaderMarket {
  domainRef: MarketId;
}

export interface ActiveProfileHeaderRole {
  context: RoleContext;
  domainRef: AppliedRoleId;
}

export interface ActiveProfileHeaderVehicle {
  domainRef: VehicleId | undefined;
}

export interface ActiveProfileHeader {
  market?: Market | ActiveProfileHeaderMarket;
  locale?: UserLocale;
  company?: {
    domainRef?: CompanyId;
  };
  userJourneyCache?: {
    domainRef?: UserJourneyCacheId;
  };
  roles?: ActiveProfileHeaderRole[] | [];
  vehicles?: ActiveProfileHeaderVehicle[] | [];
}

export async function activeProfileInterceptorStructure() {
  const activeProfileHeader: ActiveProfileHeader = {};
  const activeProfile = await loadActiveProfileFromStore();

  activeProfileHeader.market = {
    domainRef: {
      code: await aemEnvironmentHandler.getCountry(),
    },
  };
  activeProfileHeader.locale = {
    country: await aemEnvironmentHandler.getCountry(),
    language: await aemEnvironmentHandler.getLanguage(),
  };

  if (activeProfile?.user?.domainRef) {
    const { company, roles, userJourneyCache } = activeProfile;

    if (company && company.domainRef) {
      activeProfileHeader.company = {
        domainRef: company?.domainRef,
      };
    }

    if (userJourneyCache && userJourneyCache.domainRef) {
      activeProfileHeader.userJourneyCache = {
        domainRef: userJourneyCache?.domainRef,
      };
    }

    if (roles && roles.length) {
      activeProfileHeader.roles = roles.map((role: any) => ({
        domainRef: role.domainRef,
        context: role.context,
      }));
    }
  }

  if (activeProfile?.vehicles?.length) {
    activeProfileHeader.vehicles = activeProfile?.vehicles.map((vehicle: Vehicle) => ({
      domainRef: vehicle.domainRef,
    }));
  }

  return activeProfileHeader;
}

// TODO, this should be placed in the api-interceptors package, not done so far because of cycle dependency issues
export async function activeProfileInterceptor(config: AxiosRequestConfig<any>): Promise<AxiosRequestConfig<any>> {
  const activeProfileHeader = await activeProfileInterceptorStructure();

  const headers = {
    ...config.headers,
    'B2X-ActiveProfile': JSON.stringify(activeProfileHeader),
  };

  return {
    ...config,
    headers,
  };
}
